const editSwitch = {
  label: 'Alert'
};

export default editSwitch;
